import { Topbar } from "../../components/organisms/Topbar"
import { loc } from "../../core/utils"
import OrderListing from "./components/OrderListing"
import OrderSearch from "./components/OrderSearch"
import Paginator from "./components/Paginator"
import { filterStatusOptionList } from "./components/useOrderListing"
import "./style.css"
import useResumeOrder from "./useResumeOrder"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"

const ResumeOrder = ({ tunnelData, history }) => {
  const [payload, setPayload] = useState({
    shopId: null,
    orderOrName: null,
    sort: "desc",
    statusOPLs: [],
    rowsDisplayed: 10,
    offset: 0
  })

  const { orders: ordersFromBackPaginated, isLoadingOrders } = useResumeOrder(tunnelData, payload)

  function handleSearch(values) {
    if (!values) return

    setPayload((prevValue) => ({
      ...prevValue,
      shopId: values.shop ? values?.shop?.value : null,
      orderOrName: values.orderOrName ? values.orderOrName : null
    }))
  }

  function handleFilters(values) {
    if (values?.oplStatus) {
      const ALLFilterKeyName = Object.keys(filterStatusOptionList).find((x) => x === "TOUS")
      if (values.oplStatus.value === ALLFilterKeyName) {
        setPayload((prevValue) => ({ ...prevValue, statusOPLs: [] }))
      } else {
        const val = values?.oplStatus?.value !== null ? [values?.oplStatus?.value] : null
        setPayload((prevValue) => ({ ...prevValue, statusOPLs: val }))
      }
    }
    if (values?.sortBy?.value) {
      setPayload((prevValue) => ({ ...prevValue, sort: values.sortBy?.value }))
    }
  }

  function handleNextPaginate() {
    setPayload((prevValue) => ({
      ...prevValue,
      offset: prevValue?.offset + prevValue?.rowsDisplayed
    }))
  }

  function handlePreviousPaginate() {
    setPayload((prevValue) => ({
      ...prevValue,
      offset: prevValue?.offset - prevValue?.rowsDisplayed
    }))
  }

  return (
    <Container fluid>
      <Row noGutters>
        <Topbar displayToggleButton={false} tunnelData={tunnelData} history={history} />
        <Col className="main-background padding-top-7">
          <Container>
            <Row>
              <Col>
                <OrderSearch tunnelData={tunnelData} searchOrders={handleSearch} />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <OrderListing
                  orders={ordersFromBackPaginated?.data}
                  isLoadingOrders={isLoadingOrders}
                  handleFilters={handleFilters}
                />
              </Col>
            </Row>

            {!!ordersFromBackPaginated && (
              <Row className="mt-3 mb-3">
                <Col>
                  <Container>
                    <Paginator
                      totalRows={ordersFromBackPaginated?.totalRows}
                      offset={payload?.offset}
                      rowsDisplayed={payload?.rowsDisplayed}
                      translationKeys={{
                        previous: loc("previous"),
                        next: loc("next")
                      }}
                      onNext={handleNextPaginate}
                      onPrevious={handlePreviousPaginate}
                    />
                  </Container>
                </Col>
              </Row>
            )}
          </Container>
        </Col>
      </Row>
    </Container>
  )
}

export default ResumeOrder
